import React, { Component } from "react";
import * as d3 from "d3";

let twoPi = Math.PI * 2;
let width = 150,
  height = 120;
let margin = { top: 10, right: 10, bottom: 10, left: 10 };
width = width - margin.left - margin.right;
height = height - margin.top - margin.bottom;
let radius = width / 2;
let border = 10;
let endAngle = 1.35;
let startAngle = 0.65;

function drawGuage() {
  let svg = d3.select(".Infinfo svg");
  svg.attr("width", width + margin.left + margin.right);
  svg.attr("height", height + margin.top + margin.bottom);

  let arc = d3
    .arc()
    .innerRadius(radius - border)
    .outerRadius(radius)
    .cornerRadius(border)
    .startAngle(twoPi * startAngle)
    .endAngle(twoPi * endAngle);

  let g = svg
    .append("g")
    .attr(
      "transform",
      "translate(" + (radius + margin.left) + "," + (radius + margin.top) + ")"
    );

  g.append("path").attr("fill", "#d7d7d7").attr("d", arc);

  g.append("path")
    .attr("fill", "#cf5967")
    .attr("class", "pPath")
    .attr("d", arc.endAngle(twoPi * startAngle));

  g.append("text")
    .attr("class", "pTxt")
    .attr("text-anchor", "middle")
    .text("NO DATA");
}

function logPerc(val) {
  return Math.log10(val) / 2;
}
window.setGuageVal = setGuageVal;
function setGuageVal(value) {
  let svg = d3.select(".Infinfo svg");

  let arc = d3
    .arc()
    .innerRadius(radius - border)
    .outerRadius(radius)
    .cornerRadius(border)
    .startAngle(twoPi * startAngle)
    .endAngle(twoPi * endAngle);

  let maxAngle = 0.7;

  // let progress = value / 100;
  let progress = value ? logPerc(value == 1 ? 2 : value) : 0;
  let fill = "#2dd072";
  if (value > 10) fill = "#ff5232";
  svg
    .select(".pPath")
    .attr("fill", fill)
    .attr("d", arc.endAngle(twoPi * (maxAngle * progress + startAngle)));
  svg.select(".pTxt").text(value ? value + "%" : "No Data");
}

class LiabilityGuage extends Component {
  state = {
    busy: false,
  };
  setBusy = (busy) => {
    this.setState({ busy });
  };
  setData(liability) {
    setGuageVal(liability);
  }
  componentDidMount() {
    drawGuage();
  }
  render() {
    let vehiclemeta = window.selectedVehicles[0] || {};
    vehiclemeta = vehiclemeta.data || {};
    return (
      <div className="InInfo">
        <div className="Infhead">{vehiclemeta.vehiclemodel}</div>
        {this.state.busy ? (
          <div className="ipc-busy">
            <div className="ipcb-spinner"></div>
          </div>
        ) : (
          ""
        )}
        <div className="Infinfo">
          <svg></svg>
        </div>
        <div className="Inffoot">Driver Liability</div>
        <div className="Inf-legends">
          <div className="Infl-p">
            <div className="Infl-pp gr"></div>
            <div className="Infl-pt">Not Liable</div>
          </div>
          <div className="Infl-p">
            <div className="Infl-pp rd"></div>
            <div className="Infl-pt">Liable</div>
          </div>
        </div>
      </div>
    );
  }
}

export default LiabilityGuage;
